<template>

  <v-card
    :disabled="!expand && !completed"
    class="col-12 pa-0 mb-4 bt-step-card"
  >
    <v-card-title>
      {{ title }}
      <v-spacer />
      <v-btn
        v-if="expand"
        small
        outlined
        color="primary"
        @click="complete"
      >
        Add Bonus Choice
      </v-btn>
    </v-card-title>
    <v-divider v-if="expand" />

    <v-card-text class="pa-0">
      <v-expand-transition>
        <v-form
          v-if="expand"
          v-model="valid"
        >
          <v-container fluid>
            <v-card
              class="v-sheet--outlined"
              flat
            >
              <v-card-title>Bonus Choice</v-card-title>
              <v-divider />
              <v-card-text class="pa-0">

                <v-row class="ma-0">

                  <v-col cols="6">
                    <v-sheet
                      class="bonus-choice-bonus-block"
                    >
                      <v-card-title>Bonus settings</v-card-title>
                      <v-container class="px-4 py-1">
                        <v-row class="ma-0 pb-3">
                          <v-select
                            label="Bonus Type"
                            placeholder=" "
                            class="col-2 pl-0"
                            hide-details
                          />
                          <v-col cols="3" class="px-1">
                            <v-switch
                              label="Sticky Bonus"
                              placeholder=" "
                              class="mt-0"
                              hide-details
                            />
                          </v-col>
                          <v-select
                            label="Rollover Type"
                            placeholder=" "
                            class="col-2 px-2"
                            hide-details
                          />
                          <v-text-field
                            label="Wager"
                            placeholder=" "
                            class="col-2 px-2"
                            hide-details
                          />
                          <v-text-field
                            label="Deposit Amount %"
                            placeholder=" "
                            class="col-3 pl-2 pr-0"
                            hide-details
                          />
                        </v-row>
                        <v-divider />
                      </v-container>

                    </v-sheet>
                  </v-col>

                  <v-col cols="6">
                    <v-sheet
                      class="bonus-choice-bonus-block empty-block"
                    >
                      <v-row align="center" justify="center">
                        <v-btn
                          small
                          color="light-blue lighten-2 white--text"
                          @click="bonus.dialog = !bonus.dialog"
                        >
                          Add Bonus
                        </v-btn>
                      </v-row>

                    </v-sheet>
                  </v-col>

                </v-row>
              </v-card-text>
            </v-card>
          </v-container>
        </v-form>
      </v-expand-transition>
    </v-card-text>

    <bonus-dialog v-model="bonus.item" :add_bonus="addBonus" :extdialog.sync="bonus.dialog" />
  </v-card>

</template>

<style lang="scss">

  .bonus-choice-bonus-block {
    border: thin solid #E0E0E0 !important;
    height: 340px;
  }

  .bonus-choice-bonus-block .v-input--switch {
    max-width: 130px;
    margin: 0 auto;
  }

  .bonus-choice-bonus-block .v-input--switch .v-label {
    font-size: 14px;
  }

  .bonus-choice-bonus-block.empty-block .row {
    height: 100%;
  }

  .bonus-choice-bonus-block.empty-block {
    background-color: #F2F2F2;
  }

</style>

<script>
  export default {

    components: {
      BonusDialog: () => import('@/components/bonus-tools/bonus/MainView')
    },

    props: {
      step: {},
      value: {},
      next: {},
      extvalid: {},
      exteditable: {},
      extcompleted: {},
      title: {},
      expand: { default: () => false },
    },

    data: () => ({
      bonus: {
        dialog: false,
        item: {}
      }
      // valid: false
    }),

    methods: {
      addBonus (item) {
        console.log(item)
      },

      complete () {

        this.completed = true

        this.next(this.step)
      }
    },

    computed: {
      valid: {
        get () {
          return this.extvalid
        },
        set (v) {
          this.$emit('update:extvalid', v)
        }
      },
      editable: {
        get () {
          return this.exteditable
        },
        set (v) {
          this.$emit('update:exteditable', v)
        }
      },
      completed: {
        get () {
          return this.extcompleted
        },
        set (v) {
          this.$emit('update:extcompleted', v)
        }
      },
    },

    watch: {
      expand (v) {
        this.editable = true
      },
    }
  }
</script>

